import React from 'react';
import styled, { keyframes } from 'styled-components';
import { colors } from '../../styles/colors';
import AnimatedShape from '../common/AnimatedShape';

const shimmer = keyframes`
  0% { background-position: -1000px 0; }
  100% { background-position: 1000px 0; }
`;

const AboutSection = styled.section`
  padding: 6rem 5%;
  background: ${colors.white};
  position: relative;
  overflow: hidden;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;
  position: relative;
  z-index: 1;

  @media (max-width: 968px) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`;

const Content = styled.div`
  @media (max-width: 968px) {
    order: 2;
  }
`;

const Title = styled.h2`
  font-size: 2.5rem;
  color: ${colors.primary};
  margin-bottom: 2rem;
  line-height: 1.2;
  position: relative;
  
  &:after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 0;
    width: 100px;
    height: 3px;
    background: linear-gradient(90deg, ${colors.accent}, transparent);
  }
  
  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const Paragraph = styled.p`
  font-size: 1.1rem;
  line-height: 1.6;
  color: ${colors.darkGrey};
  margin-bottom: 1.5rem;
  position: relative;
  transition: transform 0.3s ease;
  
  &:hover {
    transform: translateX(10px);
  }
`;

const ProjectStatus = styled.div`
  display: inline-block;
  background: linear-gradient(45deg, ${colors.primary}, ${colors.accent});
  color: ${colors.white};
  padding: 0.5rem 1.5rem;
  border-radius: 25px;
  font-weight: 500;
  margin-top: 1rem;
  position: relative;
  overflow: hidden;
  
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 200%;
    height: 100%;
    background: linear-gradient(
      to right,
      rgba(255,255,255,0) 0%,
      rgba(255,255,255,0.3) 50%,
      rgba(255,255,255,0) 100%
    );
    animation: ${shimmer} 3s infinite linear;
  }
  
  i {
    margin-right: 8px;
  }
`;

const ImageContainer = styled.div`
  position: relative;
  height: 100%;
  min-height: 400px;
  
  @media (max-width: 968px) {
    order: 1;
    min-height: 300px;
  }
`;

const ProjectImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
`;

const About = () => {
  return (
    <AboutSection
      id="about"
      theme="light"
      density="sparse"
    >
      <Container>
        <Content>
          <Title>Welcome to Codename Forresta – Your Sanctuary in the City</Title>

          <Paragraph>
            Codename Forresta is an outstanding residential development
            brought to you by The Rudani Realty and Shree Buildcon Group, presented by Balrajeshwar
            Real Estate Pvt. Ltd. Nestled in the heart of Mulund West, Mumbai at Veena Nagar,
            Agarwal Road, 400080. Our project represents the pinnacle of urban living.
          </Paragraph>

          <Paragraph>
            Experience the epitome of luxury living with our spacious 3 and 4 BHK simplex apartments.
            Each residence is thoughtfully designed for modern families who seek the perfect blend of
            comfort, convenience, and elegance. Our homes are crafted to exceed your expectations and
            elevate your lifestyle.
          </Paragraph>

          <Paragraph>
            At Codename Forresta, we are committed to creating a serene living environment that seamlessly
            integrates with modern amenities. Every detail is carefully considered to ensure our
            residents enjoy a life of comfort and luxury in their urban sanctuary.
          </Paragraph>

          <ProjectStatus>
            <i className="fas fa-building"></i> Under Construction
          </ProjectStatus>
        </Content>

        <ImageContainer>
          <ProjectImage
            src={process.env.PUBLIC_URL + '/images/foresta-exterior.jpg'}
            alt="Codename Forresta Residential Project"
          />
        </ImageContainer>
      </Container>
    </AboutSection>
  );
};

export default About; 